export const IMAGES = {
  LANDING_BANNER: require('../../assets/images/landing-banner.png'),
  TP_LOGO: require('../../assets/images/tp-logo.png'),
  LANDING: require('../../assets/images/landing.png'),
};
